import{h as E}from"./handleize-BgPkOmuO.js";import{c as _}from"./currency.cjs-D9VPANVS.js";window.themeVariables=window.themeVariables||{};window.themeVariables.nosto=window.themeVariables.nosto||{};var v;const G=((v=window.themeVariables)==null?void 0:v.settings)||{};var V;const Y=((V=window.themeVariables)==null?void 0:V.strings)||{};var x;const g=((x=window.themeVariables)==null?void 0:x.nosto)||{};var O;const W=((O=window.themeVariables)==null?void 0:O.icons)||{};var C;const Z=((C=window.themeVariables)==null?void 0:C.productCard)||{};var j;const X=((j=window.themeVariables)==null?void 0:j.cart)||{};var q;const R=((q=window.themeVariables)==null?void 0:q.customer)||null;var F;const ee=((F=window.themeVariables)==null?void 0:F.product)||null;var U;const re=((U=window.themeVariables)==null?void 0:U.collection)||null;var D;const te=((D=window.themeVariables)==null?void 0:D.search)||null,T="global-",oe=g.popularitySortDefaultRuleId?`${T}${g.popularitySortDefaultRuleId}`:null,ie=g.customSortRuleId?`${T}${g.customSortRuleId}`:null,se={settings:G,strings:Y,nosto:g,icons:W,productCard:Z,cart:X,customer:R,product:ee,collection:re,search:te,defaultPopularitySortID:oe,customPopularitySortID:ie};function _e(r,e=!1){return r?e?ae(r):ne(r):null}function ae(r){if(!r)return null;const e=le(r.skus||[]),t=Q(e),o=de(e);return{id:r.product_id||r.id,productId:r.product_id||r.id,pid:r.product_id||r.id,name:r.name||"Product",url:r.url||"",...B(r.price,r.list_price),...L(r.image_url,r.alternate_image_urls,r.thumb_url),...o,variants:e,skus:e,tags:r.tags||[],tags1:r.tags1||[],tags2:r.tags2||[],tags3:r.tags3||[],customFields:H(r.custom_fields),attributes:r.attributes||[],affinities:t,brand:r.brand,categories:r.categories||[],description:r.description,date_published:r.date_published,price_currency_code:r.price_currency_code,price_text:r.price_text,list_price_text:r.list_price_text,variant_id:r.variant_id,handle:ce(r.url,r.name)}}function ne(r){var s,a;if(!r)return null;const e={...r},t=ue(e.skus||[]);e.id=e.pid||e.productId||null,e.name=e.name||e.title||"Product",Object.assign(e,B(e.price,e.listPrice)),Object.assign(e,L(e.imageUrl,e.alternateImageUrls)),Object.assign(e,A(e.available,e.availability)),e.customFields=e.customFields||e.attributes||[],e.tags=e.tags1||[],e.variants=t,e.skus=t,e.handle=E(e.name);const o=((s=e.url)==null?void 0:s.split("/"))||[];e.urlHandle=o.pop()||e.handle;const i=e.customFields.find(c=>{var n;return((n=c==null?void 0:c.key)==null?void 0:n.toLowerCase())==="producttype"});return e.type=(i==null?void 0:i.value)||null,e.secondaryImage=((a=e.alternateImageUrls)==null?void 0:a.length)>0?e.alternateImageUrls[0]:null,e.affinities||(e.affinities=Q(e.variants)),e}function B(r,e){return{price:parseFloat(r)||0,listPrice:parseFloat(e)||0}}function L(r,e,t=null){return{imageUrl:r||"",alternateImageUrls:e||[],...t&&{thumb_url:t}}}function A(r,e){const t=typeof r=="boolean"?r:e==="InStock";return{available:t===!0,availability:e||(t?"InStock":"OutOfStock")}}function ce(r,e){return r?r.split("/").pop():E(e||"product")}function le(r){return Array.isArray(r)?r.map(e=>{if(!e||typeof e!="object")return null;const t=H(e.custom_fields),{size:o,color:i}=J(t),s=A(e.available,e.availability);return{...e,customFields:t,size:o,color:i,...s}}).filter(Boolean):[]}function ue(r){return Array.isArray(r)?r.map(e=>{if(!e||typeof e!="object")return null;e.customFields=e.customFields||e.attributes||[];const{size:t,color:o}=J(e.customFields),i=A(e.available,e.availability);return{...e,size:t,color:o,...i}}).filter(Boolean):[]}function J(r){if(!Array.isArray(r))return{size:null,color:null};const e=r.find(o=>{var i;return((i=o==null?void 0:o.key)==null?void 0:i.toLowerCase())==="size"}),t=r.find(o=>{var i;return((i=o==null?void 0:o.key)==null?void 0:i.toLowerCase())==="color"});return{size:(e==null?void 0:e.value)||null,color:(t==null?void 0:t.value)||null}}function Q(r){const e={};if(!Array.isArray(r)||r.length===0)return e;const t=[...new Set(r.map(i=>i.size).filter(Boolean))],o=[...new Set(r.map(i=>i.color).filter(Boolean))];return t.length>0&&(e.size=t),o.length>0&&(e.color=o),e}function de(r){if(!Array.isArray(r)||r.length===0)return{available:!1,availability:"OutOfStock"};const e=r.some(t=>t.available===!0);return{available:e,availability:e?"InStock":"OutOfStock"}}function H(r){return!r||typeof r!="object"||Array.isArray(r)?[]:Object.entries(r).map(([e,t])=>({key:e,value:(t==null?void 0:t.toString())||""})).filter(e=>e.key&&e.value)}function $e(r){return Array.isArray(r)?r.map(e=>{var t;return!e||typeof e!="object"?null:{keyword:e.keyword||"",redirect:e._redirect||null,highlight:((t=e._highlight)==null?void 0:t.keyword)||e.keyword||""}}).filter(Boolean):[]}function Ne(r){if(!Array.isArray(r))return{pages:[],collections:[],keywords:[]};const e=[],t=[],o=[];for(const i of r)i.redirect&&i.redirect.includes("/pages/")?e.push({title:i.keyword,url:i.redirect,highlight:i.highlight}):i.redirect&&i.redirect.includes("/collections/")?t.push({title:i.keyword,url:i.redirect,highlight:i.highlight}):o.push(i);return{pages:e,collections:t,keywords:o}}const{nosto:m,defaultPopularitySortID:$,customPopularitySortID:N}=se,me=m.searchSizeRecs||5,P=new Map;function fe(r,e,t,o,i,s,a){return JSON.stringify({collectionId:r||null,activeFilters:e||[],currentItemCount:o,gridOffset:i,context:s,searchTerm:a||"",pageNumber:t==null?void 0:t.pageNumber,from:t==null?void 0:t.from,productsPerPage:t==null?void 0:t.productsPerPage,sort:t==null?void 0:t.sort})}const pe=m.autocompleteProductsSize||5,ye=m.keywordsSize||5;async function I(r,e,t){const o="https://search.nosto.com/v1/graphql",i={method:"POST",signal:t,headers:{"Content-Type":"application/json"},body:JSON.stringify({query:r,variables:e})};try{const s=await fetch(o,i);if(!s.ok){const a=await s.text();return console.error("Nosto search error:",{status:s.status,statusText:s.statusText,responseBody:a}),null}return await s.json()}catch(s){return console.error("Error fetching from Nosto API:",s),null}}async function he(r){const e="https://api.nosto.com/v1/graphql",t={method:"POST",headers:{"Content-Type":"application/json",Authorization:"Basic "+btoa(`:${m.authToken}`)},mode:"cors",body:JSON.stringify({query:r})};try{const o=await fetch(e,t);if(!o.ok){const i=await o.text();return console.error("Nosto recommendations error:",{status:o.status,statusText:o.statusText,responseBody:i}),null}return await o.json()}catch(o){return console.error("Error fetching from Nosto Recommendations API:",o),null}}function ge(r){const e=typeof window<"u"?window.__nostoEarlyCategorySearch:null;return!e||e.key!==r||!e.promise?null:(window.__nostoEarlyCategorySearch=null,Promise.resolve(e.promise).catch(()=>null))}async function ve(r,e,t,o,i,s="collection",a,c){const n=fe(r,e,t,o,i,s,a),f=P.get(n);if(f)return f;const l=()=>we(r,e,t,o,i,s,a,c),d=ge(n),u=d?d.then(b=>b??l()):l();return P.set(n,u),u.finally(()=>P.delete(n)),u}function be({siteId:r,searchQuery:e="",customSortRules:t="",keywordsSize:o}){return`
    query (
      $segments: [String!],
      $products: InputSearchProducts,
      $abTests: [InputSearchABTest!]
    ) {
      search(
        accountId: "${r}",
        ${e}
        ${t}
        segments: $segments
        products: $products,
        keywords: {
          size: ${o}
        }
        abTests: $abTests
      ) {
        redirect
        products {
          total
          from
          size
          hits {
            pid
            productId
            name
            url
            price
            listPrice
            imageUrl
            alternateImageUrls
            available
            tags1
            skus {
              id
              name
              availability
              price
              imageUrl
              customFields {
                key
                value
              }
            }
            affinities {
              color
              size
            }
            customFields {
              key
              value
            }
          }
          fuzzy
          facets {
            ... on SearchStatsFacet {
              name
              field
              min
              max
              id
            }
            ... on SearchTermsFacet {
              name
              field
              data {
                value
                count
                selected
              }
              id
            }
          }
        }
        keywords {
          hits {
            keyword
            _redirect
            _highlight {
              keyword
            }
          }
        }
        abTests {
          id
          name
          activeVariation {
            id
          }
          allVariations {
            id
          }
        }
      }
    }
  `}async function we(r,e,t,o,i,s="collection",a,c){var w,z,k;const{productsPerPage:n,from:f}=t;let l,d;Number.isFinite(f)?(l=Math.max(0,f),d=n):t.pageNumber>1&&o===0?(l=(t.pageNumber-1)*n,d=n):t.pageNumber>1&&o>0?(l=o,d=n):(l=0,d=n);const u={segments:m.abTestSegments||[],products:{size:d,from:l}};(w=t.sort)!=null&&w.field&&((z=t.sort)!=null&&z.order)&&t.sort.field!=="popularity"&&(u.products.sort=t.sort),s==="collection"&&(u.products.categoryId=r);const b=s==="search"&&a?`query: "${a}",`:"";e!=null&&e.length&&(u.products.filter=e);let y="";if(N&&((k=t.sort)==null?void 0:k.field)==="popularity"){let p=`{id: "${N}", enabled: true}`;$&&(p+=`,{id: "${$}", enabled: false}`),y=`customRules: [${p}],`}const h=be({siteId:m.siteId,searchQuery:b,customSortRules:y,keywordsSize:ye});try{return await I(h,u,c)}catch(p){throw console.error("Nosto search error:",p),p}}async function Ve(r){const e={products:{size:pe,from:0}},t=`
    query (
      $products: InputSearchProducts
    ) {
      search(
        accountId: "${m.siteId}",
        query: "${r}",
        products: $products,
        keywords: {
          size: 20
        },
        categories: {
          size: 10
        }
      ) {
        products {
          total
          from
          size
          hits {
            pid
            productId
            name
            url
            price
            listPrice
            imageUrl
            alternateImageUrls
            available
            tags1
            skus {
              id
              name
              availability
              price
              imageUrl
              customFields {
                key
                value
              }
            }
            affinities {
              color
              size
            }
            customFields {
              key
              value
            }
          }
          facets {
            ... on SearchTermsFacet {
              name
              field
              data {
                value
                selected
              }
              id
            }
          }
          fuzzy
        }
        keywords {
          hits {
            keyword
            _redirect
            _highlight {
              keyword
            }
          }
        }
        categories {
          hits {
            name
            url
          }
          total
        }
      }
    }
  `;try{return await I(t,e)}catch(o){return console.error("Nosto autocomplete search error:",o),null}}async function xe(r=5){var t,o,i;const e=`
    {
      search(
        accountId: "${m.siteId}"
        query: ""
        popularSearches: {size: ${r}, emptyQueryMatchesAll: true}
      ) {
        popularSearches {
          hits {
            query
            total
          }
          total
        }
        query
      }
    }
  `;try{const s=await I(e,{});return((i=(o=(t=s==null?void 0:s.data)==null?void 0:t.search)==null?void 0:o.popularSearches)==null?void 0:i.hits)||[]}catch(s){return console.error("Nosto popular searches error:",s),null}}const Pe=r=>r?`exclude: {
      productIds: '${r}'
    },`:"",Se=r=>r?`include: {
      productIds: '${r}'
    },`:"",Ae=r=>{const e=r.excludeProducts&&r.excludeProducts.length?Pe(JSON.stringify(r.excludeProducts)):"",t=r.includeProducts&&r.includeProducts.length?Se(JSON.stringify(r.includeProducts)):"";return`toplist(
    hours: ${r.toplistHours},
    sort: ${r.toplistScoringMode},
    params: {
      maxProducts: ${r.searchSize||me},
      ${e}
      ${t}
    }
  )`};async function Oe(r){let e;e=Ae(r);const t=`{
    recos(
      preview: false,
      image: VERSION_SOURCE
    ) {
      ${e} {
        primary {
          productId
          name
          url
          price
          listPrice
          imageUrl
          alternateImageUrls
          availability
          tags1
          skus {
            id
            name
            availability
            price
            imageUrl
            attributes {
              key
              value
            }
          }
          attributes {
            key
            value
          }
        }
      }
    }
  }`;try{return await he(t)}catch(o){return console.error("Nosto recommendations error:",o),null}}function Ce(r,e,t){if(!r||!e||!t){console.warn("Missing required product data for Nosto tracking");return}window.nostojs(o=>{o.recordSearchClick(r,{productId:e,url:t})})}function je(r,e,t){if(Object.keys(e).length===0)return;const o={query:e.term,products:{sort:e.sort,filter:e.filter}},i={products:{hits:Array.isArray(t)?t.map(a=>({productId:a.productId})):[],fuzzy:e.fuzzy,size:e.size,from:e.from,total:e.total},properties:{}},{abTests:s}=e;if(s!=null&&s.length){const a=Object.fromEntries(s.filter(c=>{var n;return c.id&&((n=c.activeVariation)==null?void 0:n.id)}).map(c=>[c.id,c.activeVariation.id]));Object.keys(a).length&&(i.properties.abTestAttribution=a,i.abTests=s)}r==="category"&&(i.products.categoryPath=e.term),window.nostojs(a=>{a.recordSearch(r,o,i)})}function qe(r,e){if(!r){console.warn("Missing product ID for Nosto recommended product tracking");return}window.nostojs(t=>{t.recommendedProductAddedToCart(r,e||"")})}const K=()=>{var e;const r=document.querySelector("cart-drawer .nosto_element");r&&((e=window.Nosto)==null||e.reloadCart([r.id]),setTimeout(()=>{r.style.opacity="1"},2e3))};document.addEventListener("cart-drawer:refreshed",()=>{K()});document.addEventListener("DOMContentLoaded",()=>{K()});var M;const S=((M=window.themeVariables)==null?void 0:M.settings)||{},Ie=(r,e=!0)=>{const t=window.Shopify.currency.active,o=S.shopCurrency,i=e?S.moneyFormat:S.moneyWithoutCurrencyFormat;if(o===t)return _.formatMoney(r*100,i);let s=r*100*window.Shopify.currency.rate,a=!1,c=0,n=0,f=.1,l=.05;switch(t){case"USD":case"HKD":case"SAR":case"AED":l=0;break;case"NZD":l=.1,c=.15;break;case"JPY":a=!0;break;case"SGD":l=.05,c=.09;break;case"CAD":l=.05,n=.03;break;default:l=.05}n!==0&&(s=s*(1+n)),o==="AUD"&&c!==0&&(s=s/(1+f)*(1+c));const u=Math.floor(s)/100;let y=(Math.ceil(u)-l)*100;if(a){const h=Math.trunc(s),w=h.toString().slice(-3);y=parseInt(w)>=50?Math.ceil(h/1e4)*1e4:Math.floor(h/1e4)*1e4}return _.formatMoney(y,i)};window.theme.localPrice=window.localPrice||Ie;export{Ce as a,je as b,se as c,Oe as d,Ve as e,$e as f,ve as g,xe as h,Ie as l,qe as n,Ne as s,_e as t};
